import "core-js/modules/es6.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 租户部分  start
import videoTemp from "./videoTemp"; // 租户部分  end

import wasteWater from "../st32/wasteWater";
import overStandard from "./overStandard";
import warn from "./warn";
import videoItem from "./video";
import siteFiles from "./siteFiles.vue";
import { queryBigDataById, queryUrlBySiteId } from '@/api/api';
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import noneImg from '@/assets/others/index/none2.png';
import PathReview from '@views/dashboard/com/pathReview';
import operationFiles from '@/views/dashboard/com/operationFiles.vue';
import enterprisEnv from "../st32/enterprisEnv.vue";
import { getAction } from '@/api/manage';
import { isYongChun } from '@/utils/util';
export default {
  data: function data() {
    return {
      tenantCode: window.localStorage.getItem('tenant'),
      showPath: false,
      widthChange: true,
      noneImg: noneImg,
      frameUrl: '',
      currentItem: '实时数据',
      navList: ['监测数据', '视频监控', '站点档案', '运维档案'],
      selectId: '0',
      siteDetail: {},
      operationData: {},
      url: {
        imgerver: window._CONFIG['domianURL'] + '/sys/common/file/view'
      },
      selectType: '0',
      siteId: '',
      timer: null
    };
  },
  components: {
    videoTemp: videoTemp,
    PathReview: PathReview,
    siteFiles: siteFiles,
    overStandard: overStandard,
    warn: warn,
    videoItem: videoItem,
    wasteWater: wasteWater,
    operationFiles: operationFiles,
    enterprisEnv: enterprisEnv
  },
  created: function created() {
    var _this = this;

    window.addEventListener('resize', function () {
      _this.widthChange = false;
      _this.timer = setTimeout(function () {
        _this.widthChange = true;
      }, 100);
    }, false);
  },
  destroyed: function destroyed() {
    clearTimeout(this.timer);
  },
  methods: {
    onTabChange: function onTabChange(item) {
      var _this2 = this;

      this.currentItem = item;

      if (item == '实时数据' || item == '监测数据' || item == '站点档案') {
        var data1 = JSON.parse(JSON.stringify(this.selectId));
        this.selectId = '0';
        this.$nextTick(function () {
          _this2.selectId = data1;
        });
      }

      if (item == '视频监控') {
        this.$nextTick(function () {
          console.log('this.$refs.video', _this2.selectType);
          _this2.$refs.video ? _this2.$refs.video.getVideoList(_this2.siteId) : '';
        });
      }

      if (item == '三维工况') {
        this.$nextTick(function () {
          _this2.$refs.video.getVideoList(_this2.siteId);
        });
      }
    },
    getType: function getType(data, res) {
      var _this3 = this;

      this.selectType = data.siteType;
      this.siteId = data.siteId;
      res ? this.handleSiteData(res) : this.getsiteDetail(data.siteId);
      queryUrlBySiteId(data.siteId).then(function (res) {
        if (res.result) {
          _this3.frameUrl = res.result;
        } else {
          _this3.frameUrl = 'https://www.skyray-water.com:4001/view/yesep_env/3?site_id=' + value + '&isCron=1&token=' + Vue.ls.get(ACCESS_TOKEN);
        }
      }).catch(function () {
        _this3.frameUrl = 'https://www.skyray-water.com:4001/view/yesep_env/3?site_id=' + _this3.siteId + '&isCron=1&token=' + Vue.ls.get(ACCESS_TOKEN);
      });
      this.$nextTick(function () {
        // this.getsiteDetail(data.siteId)
        _this3.getOperationData(data.siteId);

        if (_this3.currentItem == '视频监控') {
          _this3.$refs.video.getVideoList(data.siteId);
        }

        _this3.selectId = data.siteId.toString();
      });
    },
    getOperationData: function getOperationData(id) {
      var _this4 = this;

      var params = {
        siteId: id
      };
      getAction('site/info/devops/getBySite', params).then(function (res) {
        if (res.success) {
          _this4.operationData = res.result;
        }
      });
    },
    getsiteDetail: function getsiteDetail(id) {
      var _this5 = this;

      queryBigDataById({
        id: id
      }).then(function (res) {
        _this5.handleSiteData(res);
      });
    },
    handleSiteData: function handleSiteData(res) {
      if (res.success) {
        this.navList = ['监测数据', '视频监控', '站点档案', '运维档案'];
        this.showPath = false;
        res.result.photo = res.result.photo != null ? this.getImageView(res.result.photo) : '';
        this.siteDetail = res.result;
      }
    },
    getImageView: function getImageView(photo) {
      return this.url.imgerver + '/' + photo;
    }
  }
};